import React from 'react';

const SvgAddUser: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.47 3.023A3.492 3.492 0 117.53 7.96a3.492 3.492 0 014.94-4.938m1.893 9.774c-1.299-.519-2.823-.805-4.363-.805-4.048 0-8 1.967-8 4.992v1a1 1 0 001 1h9.413" />
        <path d="M17 22a5 5 0 01-5-5c0-2.704 2.3-5.003 5.004-5A5 5 0 0117 22m0-7v4m2-2h-4" />
      </g>
    </svg>
  );
};

export default SvgAddUser;
